// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"530":"8e3da9b6","4960":"1f5b8673","6253":"f385f2cb","7887":"6de7cd5b"}[chunkId] + ".chunk.css";
};